<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kcTiQU/tc-custom/9781788634861.jpg?1703867500990" alt="This image is the cover for the book Odds Against"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Odds Against
      </h1>
      <p class="bookDescription body article font2">
        <b>From the <i>New York Times</i>–bestselling “master of crime fiction and equine thrills,” a jockey turned investigator tackles crime in the horse racing world <i>(Newsday)</i>.</b><br/>  <br/> Dick Francis, Edgar Award–winning master of mystery and suspense, takes you into the thrilling world of horse racing.<br/>  <br/> A hard fall took hotshot jockey Sid Halley out of the horse racing game, leaving him with a crippled hand, a broken heart, and the desperate need for a new job. Now he’s landed a position with a detective agency, only to catch a bullet from some common thug. And things are about to get even more hectic. The agency is giving him a case to handle on his own.<br/>  <br/> The case brings him to the door of Zanna Martin, a woman who might be just what Sid needs to get him back up and running. But he’s up against a field of thoroughbred criminals, and the odds against him are making it a long shot that he’ll even survive . . .<br/>  <br/> “Dick Francis is a wonder.” —<i>The Plain Dealer</i><br/><br/> “An imaginative craftsman of high order.” —<i>The Sunday Times</i><br/><br/> “Few things are more convincing than Dick Francis at a full gallop.” —<i>Chicago Tribune</i><br/><br/> “Few match Francis for dangerous flights of fancy and pure inventive menace.” —<i>Boston Herald</i><br/><br/> “[The] master of crime fiction and equine thrills.” <i>—</i><i>Newsday</i><br/><br/> “[Francis] has the uncanny ability to turn out simply plotted yet charmingly addictive mysteries.” —<i>The </i><i>Wall Street Journal</i><br/><br/> “Francis is a genius.” <i>—</i><i>Los Angeles Times</i><br/><br/> “A rare and magical talent . . . who never writes the same story twice.” —<i>The </i><i>San Diego Union-Tribune</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dick Francis
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Digital Publishing Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1b803c98